import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import { AppState } from 'app/App Store/state';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { setPageNumber } from 'app/App Store/actions/pageChange.actions';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss',
  "../../../../../../assets/sass/libs/datatables.scss",],
encapsulation: ViewEncapsulation.None,
})
export class ListComponent implements OnInit {

    @ViewChild(DatatableComponent) table: DatatableComponent;
    page = {
      pageNumber:0,
      offset: 0,
      pageSize: 100,
      totalPages:0
    };
    // row data
    public rows = [];
    public filterRows=[];
    public ColumnMode = ColumnMode;
    public limitRef = 100;
    selectedValue=''
    isFilter:boolean=false
    public columns = [
      { name: "Title", prop: "title" },
      {name:"Company",prop:"company"},
      { name: "Category", prop: "category" },
      { name: "Employment Type", prop: "employment_type" },
      { name: "Actions", prop: "Actions" },
    ];
  
    // private
    private tempData = []; 
  
    imageUrl=environment.apiUrls.imageUrl;
    
  
    tag_id:any
    searchVal:any;
    @ViewChild('name') inputName
    user_role:any
    opening_status_cat_id ='64c246476ae6f958da59fae3'
    status_list =[]
    activeTab=''
    opening_id:any
    users_list =[]
    selected_user =null
    selected_shortlist_user =null
    isAppliedFor : boolean = false
    prop: string;
    isUpdate :boolean =false
    guideline_data:any
   
    pageNumberSubscription : Subscription
    pageNo
    constructor( public apiService:ApiService,private modalService: NgbModal,
                 public toastr: ToastrService,private activerouter : ActivatedRoute,
                 private spinner: NgxSpinnerService, private route: Router,private store: Store<AppState>) { 
                  this.user_role=JSON.parse(localStorage.getItem('user'))
                  let setting_data = JSON.parse(localStorage.getItem('setting-record'))
                  let key_data = setting_data.filter((item) => item.key === 'Opening')
                  this.guideline_data = key_data[0]?._id 

                  this.activerouter.queryParams
                .subscribe((params: any) => {
                  this.activeTab = params['status'];
                  this.pageNo = +params['page'];
                  if(this.pageNo>0){
                    this.setPage(this.pageNo);
                  }
                  else this.page.pageNumber = this.pageNo?this.pageNo-1:0
                })
                this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
                .subscribe(pageNumber => {
                  this.page.pageNumber = pageNumber;
                  if(pageNumber !==undefined){
                    this.page.pageNumber = pageNumber ?  pageNumber-1 :0
                  }
                });
                this.getStatusList()

                if(this.activeTab) this.activeEmployeeTab(this.activeTab,this.pageNo?this.pageNo:1)
                if(!this.activeTab) this.activeEmployeeTab('open',this.pageNo?this.pageNo:1)
              }
  
    ngOnInit(): void {
     
      this.getAllCandidate()
    }
    setPage(pageNumber: number) {
      this.store.dispatch(setPageNumber({ pageNumber }));
    }
   
    getStatusList(){
      this.apiService.getTagByTagCatgoryId(this.opening_status_cat_id).subscribe((res:any)=>{
        this.status_list=res.data
        this.setAndGetEmployeebyStatus()
      })
    }
    activeEmployeeTab(tab,page) {
      if(page<1){ page =1}
      const activetab = tab;
      this.activeTab = tab
      if (activetab !== '') {
        this.route.navigate(
          [],
          { relativeTo: this.activerouter, queryParams: { status: activetab ,  page : page },queryParamsHandling: 'merge' }
        );
      }
    }
    setAndGetEmployeebyStatus() {
      this.activerouter.queryParams
        .subscribe((params: any) => {
          this.activeTab = params?.status;
          this.getOpeningList()
        })
    }
 
    getOpeningList(){
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      let status = this.status_list.find((item) => item.name == this.activeTab);
      this.apiService.getOpeningListByStatus(status._id).subscribe((res:any)=>{
        this.spinner.hide();
        this.rows=res?.data?.items
        this.page.totalPages=res?.data?.totalCount
      })
    }
    pageChangeData(page:any){
      this.route.navigate([], {
        relativeTo: this.activerouter,
        queryParams: { page: page.offset +1 },
        queryParamsHandling: 'merge' // keep existing query params
      });
      // this.apiService.getTagsList(page.offset +1,page.pageSize).subscribe((res:any)=>{
      //   this.setPage(page.offset +1)
      //   this.rows=res.data.items
      //   this.page.totalPages=res.data.totalCount
    
      // })
    }
    getTagsFilter(data:any){
      // let search=data
      // if(search){
      //   this.apiService.getTagSearch(search).subscribe((res:any)=>{
      //     this.rows=res.data
      //   })
      // }
      
    }
    resetFilter(){
      this.inputName.nativeElement.value=''
      // this.getAllTag()
    }
    editTag(id:any){
    }
    deleteOpening(password){
      if(this.opening_id){
        this.apiService.deleteOpening(this.opening_id,password).subscribe((res:any)=>{
          if(res.statusCode === 200){
            swal.fire({
              icon: "success",
              title: 'Deleted!',
              text: 'Your file has been deleted.',
              customClass: {
                confirmButton: 'btn btn-success'
              },
            })
            this.setAndGetEmployeebyStatus()
          }
          else{
            swal.fire({
              icon: "error",
              title: 'Error!',
              text: `${res.error}`,
              customClass: {
                confirmButton: 'btn btn-success'
              },
            })
          } 
          })
      }
      else{
        this.toastr.error('something went wrong !!')
      }
    }
     // ================== Delete Alert ========================
     ConfirmColor(id:any) {
        this.opening_id = id
        swal.fire({
          text: "Please Enter Password",
          input: 'password',
          showCancelButton: true,
        }).then((result) => {
          if (result.value) {
            this.deleteOpening(result.value)
    
          } else if (result.dismiss === swal.DismissReason.cancel) {
            swal.fire({
              title: 'Cancelled',
              text: 'Your file is safe :)',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success'
              },
            })
          }
        });
    }
  updateStatus(status_id, row_id) {
    let body = {
      status : status_id
    }
    this.apiService.updateOpening(row_id, body).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.toastr.success('status update successfull')
        this.setAndGetEmployeebyStatus()
      }
      else this.toastr.error(res.error)
    })
    }
    getAllCandidate(){
      this.apiService.getAllCandidates(1, 100).subscribe((res: any) => {
          this.users_list=res?.data?.items
        })
      }
    getUserId(event) {
      this.selected_user
    }
    getShortUserId(event) {
      this.selected_shortlist_user
    }
    openModal(content,prop,id,data){
      this.opening_id = id
      this.prop =prop

      if(prop == 'applied_for'){
        this.isAppliedFor =true
        if(data !='null'){
          this.selected_user = data.map(item => item._id)
          this.isUpdate = true
        }
      }
      if(prop == 'sort_listed'){
        this.isAppliedFor =false
        if(data !='null'){
          this.selected_user = data.map(item => item._id)
          this.isUpdate = true
        }
      }
      
      const modalRef = this.modalService.open(content);
    
        modalRef.result.then((result) => {
          // console.log(`Modal closed with result: ${result}`);
        }, (reason) => {
          // console.log(`Modal dismissed with reason: ${reason}`);
        });
    }

   
    add(){
      if(this.prop == 'applied_for'){
        let body ={
          applied_for : this.selected_user
        }
        this.apiService.updateOpening(this.opening_id,body).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.toastr.success('added successfull')
            this.setAndGetEmployeebyStatus()
          }
          else this.toastr.error(res?.error)
        })
      }
      if(this.prop == 'sort_listed'){
        let body ={
          sort_listed : this.selected_shortlist_user
        }
        this.apiService.updateOpening(this.opening_id,body).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.toastr.success('added successfull')
            this.setAndGetEmployeebyStatus()
          }
          else this.toastr.error(res?.error)
        })
      }
    }
    copyRow(data){
      let date = new Date()
      let title = data?.title + moment(date).format('MMMM Do YYYY, h:mm:ss a')
      let body ={
        title: title ,
        salary: data?.salary,
        website: data?.website,
        deadline: data?.deadline,
        location: data?.location,
        description: data?.description,
        contact_email:   data?.contact_email,
        contact_phone:  data?.contact_phone,
        responsibilities: data?.responsibilities,
        status: '64c2466d6ae6f958da59faee',
        company: data?.company?._id,
        category: data?.category?._id,
        employment_type: data?.employment_type?._id,
        notes:  data?.notes,
        admin_notes: data?.admin_notes,
        experience: data?.experience,
        applied_for : data?.applied_for.map(item => item._id),
        sort_listed : data?.sort_listed.map(item => item._id),
        
      }
      this.apiService.createOpening(body).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success('Copied Successfull')
          this.setAndGetEmployeebyStatus()
        }
        else{this.toastr.error(res.error)}
      })
    }
    openDynamicModal(key_id:string) {
      const modalOptions: NgbModalOptions = {
        size: 'lg', // 'sm', 'lg', or 'xl'
        backdrop: 'static',
      };
      const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
      modalRef.componentInstance.key_id = key_id;
    }
  }
  